import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import TableColumn from './Components/TableColumn';

const TableHeader = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement(TableColumn, {
    title: "Item",
    className: styles.col
  }), /*#__PURE__*/React.createElement(TableColumn, {
    title: "type / status",
    className: styles.col
  }), /*#__PURE__*/React.createElement(TableColumn, {
    title: "Amount / Time",
    className: styles.col
  }));
};

export default TableHeader;